export const BED_STATUS = {
  available:    { label: "Available",    chipColor: "success",   clickable: false },
  occupied:     { label: "Occupied",     chipColor: "error",     clickable: true  },
  reserved:     { label: "Reserved",     chipColor: "warning",   clickable: true  },
  cleaning:     { label: "Cleaning",     chipColor: "info",      clickable: true  },
  housekeeping: { label: "Housekeeping", chipColor: "secondary", clickable: false },
  maintenance:  { label: "Maintenance",  chipColor: "default",   clickable: false },
  decomposed:   { label: "Decomposed",   chipColor: "default",   clickable: false },
};

export function statusCfg(s) {
  return BED_STATUS[String(s || "").toLowerCase()] || { label: s, chipColor: "default", clickable: false };
}
